module.exports = __webpack_public_path__ + "pitcairn-islands.svg?0baace9ef835e4f614d306046a4dd7c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/pitcairn-islands.svg
// module id = 267
// module chunks = 10